import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { orderCancellationUrl } from '@app/helpers';
import { OrderCancellationStateService } from '../order-cancellation-state.service';

export const orderCancellationListGuard = (route: ActivatedRouteSnapshot) => {
  if (inject(OrderCancellationStateService).orderDetails) {
    return true;
  }
  if (route.queryParams['orderNumber']) {
    return true;
  }
  return inject(Router).parseUrl(orderCancellationUrl);
};
